import { Link } from 'react-router-dom';

import { getDomain } from '@helpers/domain.helper';

function Footer() {
  return (
    <footer className="p-3 d-print-none">
      <small>
        &copy;{getDomain()} 2014-2026 | <Link to="/about">О Сайте</Link>
        {' | '}
        <Link to="/terms">Условия использования и политика конфиденциальности</Link>
      </small>
    </footer>
  );
}

export default Footer;
